import { useQuery } from '@tanstack/react-query'
import apiClient from '@/apiClient'
import type { CashSummary } from '@/types/backend'

export const useCashSummaryQuery = (from?: string, to?: string) =>
  useQuery({
    queryKey: ['cash', 'summary', { from, to }],
    queryFn: async () => {
      const { data } = await apiClient.get<CashSummary>('/cash/_summary', {
        params: { from, to },
      })
      return data
    },
  })
